import React, { FC, useState } from 'react'
import { Typography } from 'react-components'
import { CTAButton, StyledGhostButton } from '../style'
import { FormattedBookingTypeData } from '../../../models/property-details-page/booking-type-model'
import { SearchbarFieldsReturn } from '../hooks/use-searchbar'
import get from 'lodash/get'
import getChildrenAges from '../utils/get-children-ages'
import useDynamicQueryParams from '../hooks/use-dynamic-query-params'
import { pdpPageActions } from '../../../services/analytics-service/actions'
import AnalyticsService from '../../../services/analytics-service'
import { getSearchDate } from '../../../utils/miscellaneous-utils'
import updateDateRetentionCookies from '../utils/update-date-retention-cookies'
import { MailPickerIcon } from '../../search-result-listing/header-section/searchbar/widget-styles'
import { useTranslation } from '../../../hooks/locale'
import { PdpToCheckoutPosition } from '../constants'
import { usePropertyDetailsContext } from '../../../hooks/property-details'
import { getCategory } from '../../../utils/category-utils'
import { useRouter } from 'next/router'
import { ShareIconWrapper } from './styles'

type BindingInquiryButtonProps = {
    bookingType: FormattedBookingTypeData | null
    searchbar: SearchbarFieldsReturn
    showShortTitle?: boolean
    position:
        | PdpToCheckoutPosition.GALLERY
        | PdpToCheckoutPosition.SIDEBAR
        | PdpToCheckoutPosition.STICKY_FOOTER
        | PdpToCheckoutPosition.PRICE_WIDGET
        | PdpToCheckoutPosition.COMBO_LISTING_POPUP
}

const BindingInquiryButton: FC<BindingInquiryButtonProps> = props => {
    const [isLoading, setIsLoading] = useState(false)
    const { bookingType, searchbar, position, showShortTitle = false } = props
    const dynamicQueryParams = JSON.parse(get(bookingType, 'dynamicQueryParams', '') || '')
    const childrenAges = getChildrenAges(searchbar.kids)
    const { query } = useRouter()
    const qpValues = { ...query, ...searchbar, childrenAges }
    const url = useDynamicQueryParams(bookingType, qpValues, dynamicQueryParams)
    const type = get(bookingType, 'type')
    const { t } = useTranslation()
    const { isComboListing } = usePropertyDetailsContext()

    const titleKey = showShortTitle ? 'shortTitle' : 'title'

    const onBindingInquiryClick = (event: React.MouseEvent) => {
        setTimeout(() => {
            AnalyticsService.trackEvent({
                category: getCategory(isComboListing),
                action: pdpPageActions.BOOK_NOW_BUTTON_CLICKED,
                label: position,
            })
        }, 0)
        const arrival = getSearchDate(searchbar.arrival)
        const departure = getSearchDate(searchbar.departure)
        const adultsCount = searchbar.adults
        const childrenCount = searchbar.kids
        updateDateRetentionCookies(arrival, departure, adultsCount, childrenCount, searchbar.location)
        if (type === 'redirect') {
            event.preventDefault()
            setIsLoading(true)
            window.open(url, '_blank')
            setIsLoading(false)
        } else {
            setIsLoading(true)
            window.location.href = url
            setTimeout(() => {
                setIsLoading(false)
            }, 5000)
        }
    }

    return (
        <CTAButton onClick={onBindingInquiryClick}>
            <StyledGhostButton
                isPrimary={false}
                disabled={isLoading ? true : undefined}
                loading={isLoading ? true : undefined}
                buttonSize="large"
            >
                <ShareIconWrapper isPrimary={false}>
                    <MailPickerIcon alt={t('mailIconText')} style={{ position: 'unset' }} />
                </ShareIconWrapper>
                <Typography variant="subtitle2" fontWeight="semiBold">
                    {get(bookingType, titleKey)}
                </Typography>
            </StyledGhostButton>
        </CTAButton>
    )
}

export default BindingInquiryButton
